<template>
	<div id="offers-table">
		<table class="table" v-if="tableRows.length != 0 && !isLoadingOriginatorOffers">
			<thead class="table__header">
				<tr>
					<th
						v-for="(header, index) in tableHeader"
						@click="orderByHeader(header)"
						:class="header.field == 'edit' || header.field == 'delete' ? 'icon' : ''"
						:key="index"
					>
						<div class="row">
							<span :class="header.field == 'actions' ? '' : 'pointer'">{{ header.label }}</span>
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr
					v-for="(row, index) in tableRows"
					:key="row.id"
					:class="[index % 2 == 0 ? 'stripped' : '', row.isInvalid ? 'invalid' : '']"
				>
					<td>
						{{ row.originator != null ? row.originator.name : ' - ' }}
					</td>
					<td>
						{{ row.industryType != null ? row.industryType.name : ' - ' }}
					</td>
					<td>
						{{ row.assetCode }}
					</td>
					<td>
						{{
							row.saleOffEstimatedDate
								? $moment(row.saleOffEstimatedDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
								: ' - '
						}}
					</td>
					<td class="actions">
						<span @click="editRow(row)"><EditIcon :size="24" :border="'#0047ff'" /></span>
					</td>
				</tr>
			</tbody>
		</table>
		<div class="loader" v-if="isLoadingOriginatorOffers">
			<SpinnerIcon :color="'#597393'" />
		</div>
		<Pagination
			v-if="tableRows.length != 0 && !isLoadingOriginatorOffers"
			:totalPages="totalPages"
			:currentFromReq="currentPage"
			@tableRequest="tableRequest"
		/>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SidebarArrow from '@/components/shared/Icons/SidebarArrow.vue';
import Pagination from '@/components/shared/Pagination/Pagination';
import SpinnerIcon from '@/components/shared/Icons/SpinnerIcon';
import EditIcon from '@/components/shared/Icons/EditIcon.vue';
import { GET_ALL_INDUSTRY, GET_ALL_OFFER_STATUS } from '@/store/modules/offerManagement/actions';

export default {
	name: 'OfferTable',
	components: {
		SidebarArrow,
		Pagination,
		SpinnerIcon,
		EditIcon,
	},
	props: {
		isWeb: {
			required: true,
		},
		currentPage: {
			required: true,
		},
	},
	data: () => ({}),
	mounted() {
		this.getAllIndustries({ vm: this });
		this.getAllOfferStatus({ vm: this });
	},
	methods: {
		...mapActions('offerManagement', {
			getAllIndustries: GET_ALL_INDUSTRY,
			getAllOfferStatus: GET_ALL_OFFER_STATUS,
		}),
		tableRequest(param) {
			this.$emit('changePage', param);
		},
		orderByHeader(param) {
			if (param.field == 'actions') return;
			this.$emit('orderByHeader', param.field);
		},
		editRow(row) {
			const id = this.$route.query.id;

			this.$router.push({
				path: '/dashboard/offer/detail',
				query: { id: row.id, originator: id },
			});
		},
	},
	computed: {
		...mapGetters('originatorManagement', ['originatorOffersList', 'isLoadingOriginatorOffers']),
		tableHeader() {
			return [
				{
					field: 'originator',
					label: 'Empresa - Originador',
				},
				{
					field: 'industryType',
					label: 'Indústria',
				},
				{
					field: 'assetCode',
					label: 'Código do Ativo',
				},
				{
					field: 'saleOffEstimatedDate',
					label: 'Data de Bookbuilding',
				},
				{
					field: 'actions',
					label: 'Ações',
				},
			];
		},
		tableRows() {
			const rows =
				this.originatorOffersList.offers != undefined ? this.originatorOffersList.offers : [];

			return !rows.length ? [] : rows;
		},
		totalPages() {
			const pagination =
				this.originatorOffersList.totalPages != undefined
					? this.originatorOffersList.totalPages
					: 1;

			return pagination;
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'OfferTable.scss';
</style>
